import React from "react"

type Props = {
}

const Countdown: React.FC<Props> = ({}) => {
  return (
    <div className="py-12 lg:py-16 bg-[#f3b247]">
      <div className="container px-2 lg:px-0">
        <h3 className="text-center uppercase text-2xl md:text-3xl lg:text-4xl font-gilroy font-bold">Amount Raised</h3>

        <div className="mt-8 flex justify-center">
          <div className="flex flex-col items-center">
            <span className="text-5xl font-gilroy font-medium mb-1">£203,242</span>
            <span className="font-gilroy font-bold uppercase tracking-wider">Total raised</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Countdown
